var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-event-box"},[(_vm.list.length === 0)?_c('div',{staticClass:"new-event-empty"},[_c('el-empty',{attrs:{"image-size":70,"description":"暂无事件"}})],1):_c('div',{staticClass:"new-event-content"},[_c('div',{staticClass:"new-event-list"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }